<template>
  <div id="cat" v-cloak>
    <div class="vx-card mb-3">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body pb-3">
          <div class="flex">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
              >
                <div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
          <div class="vx-row" v-if="showFilters">
            <div class="vx-col w-full">
              <form>
                <div class="vx-row">
                  <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mt-1">
                    <label class="vs-select--label">{{
                      $t("PartyName")
                    }}</label>
                    <treeselect
                      name="genericProduct"
                      :multiple="false"
                      placeholder=""
                      :async="true"
                      :load-options="loadOptions"
                      v-validate="'required'"
                      class="search-input"
                      ref="genericProduct"
                      @select="SelectPartyName"
                    />
                  </div>

                  <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mt-1">
                    <label class="vs-select--label mb-1">{{
                      $t("TransactionType")
                    }}</label>
                    <v-select
                      label="name"
                      :options="customers"
                      v-model="gridSearchData.FinancialTransactionQueryType"
                      :reduce="(x) => x.id"
                      :clearable="false"
                      ref="FinancialTransactionType"
                    >
                    </v-select>
                  </div>
                  <div class="vx-col w-full lg:w-1/4 sm:w-1/2">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("FromDate")
                    }}</label>
                    <date-picker
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker"
                      v-model="gridSearchData.FromDate"
                      :label="$t('FromDate')"
                      :clearable="true"
                    />
                  </div>

                  <div class="vx-col w-full lg:w-1/4 sm:w-1/2">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("ToDate")
                    }}</label>
                    <date-picker
                      type="datetime"
                      format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss"
                      class="date-picker"
                      v-model="gridSearchData.ToDate"
                      :label="$t('ToDate')"
                      :clearable="true"
                    />
                  </div>
                </div>
                <div class="mt-4 flex gap-4 justify-end">
                  <vs-button
                    type="filled"
                    color="#3ec9d6"
                    @click.prevent="resetForm()"
                    >{{ $t("ResetFilter") }}</vs-button
                  >
                  <vs-button type="filled" @click.prevent="submitFilter()">{{
                    $t("SubmitFilter")
                  }}</vs-button>
                </div>
              </form>
            </div>
          </div>
          <div class="vx-row pt-4">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('PartyName'), sort: 'partyFullname' },
                  { title: $t('Amounts'), sort: 'amount' },
                  { title: $t('CreationDates'), sort: 'createOn' },
                  {
                    title: $t('TypeFinancialTransaction'),
                    sort: 'financialTransactionQueryType',
                  },
                  { title: $t('ReferenceID'), sort: 'reasonId' },
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 25%">
                    {{ row.partyFullname }}
                  </td>
                  <td style="width: 20%">
                    {{ Number(row.amount).toLocaleString() }}
                  </td>
                  <td style="width: 15%; direction: ltr">
                    {{ row.createOn.split(" ")[0] }}<br />{{
                      row.createOn.split(" ")[1]
                    }}
                  </td>
                  <td style="width: 17%">
                    <span v-if="row.financialTransactionQueryType == '2'">
                      {{ $t("Removal") }}
                    </span>
                    <span v-if="row.financialTransactionQueryType == '1'">
                      {{ $t("Deposit") }}
                    </span>
                  </td>
                  <td style="width: 15%">
                    {{ row.reasonId }}
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "@/components/CustomVSelect.vue";
import { mapActions } from "vuex";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "CreditManagement_Transactions_Index",
  components: {
    DataGrid,
    Treeselect,
    "v-select": vSelect,
  },
  data() {
    return {
      showFilters: false,
      customers: [
        { name: "برداشت", id: 2 },
        { name: "واریز", id: 1 },
      ],
      gridDataSource: {
        type: "app",
        service: "Credits/api/FinancialTransactionQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  methods: {
    ...mapActions({
      ConvertNameToIdForParty: "SalesPartnerPlan/ConvertNameToIdForParty",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.ConvertNameToIdForParty(searchQuery).then((r) => {
              const options = [];
              r.data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    SelectPartyName(data) {
      this.gridSearchData.PartyId = data.id;
    },
    resetForm() {
      this.gridSearchData = {
        PartyId: null,
        FormDate: null,
        ToDate: null,
        FinancialTransactionQueryType: null,
      };
      setTimeout(() => {}, 0);
    },

    submitFilter() {
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
